/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import {
  ContextRoute,
  getContextRouteInitData,
  getContextRouteStaticData,
} from '@gh/common-internal-shared';
import { assign } from 'lodash';
import { ContactDetailsFormState } from '../contact-details-tab-container/contact-details-form.service';
import { ContactDetailsSharedCustomFieldsFormState } from './contact-details-shared-custom-fields-form.service';

@Component({
  standalone: false,
  selector: 'gh-contact-details-shared-custom-fields-tab',
  templateUrl: 'contact-details-shared-custom-fields-tab.component.html',
  styleUrls: ['contact-details-shared-custom-fields-tab.component.scss'],
})
export class ContactDetailsSharedCustomFieldsTabComponent implements OnInit {
  form: ContactDetailsSharedCustomFieldsFormState;
  tab: string;

  constructor(private route: ContextRoute,
              rootForm: ContactDetailsFormState) {
    this.tab = getContextRouteStaticData(this.route)['tab'];
    this.form = <ContactDetailsSharedCustomFieldsFormState>rootForm
      .getChildForm(this.tab)
      .getChildForm('customFields');
  }

  ngOnInit(): void {
    assign(this, getContextRouteInitData(this.route));
  }
}
